<template>
  <div :class="classObj" class="ccui-app-wrapper">
    <!--    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside"/>-->
    <compatible-warning v-if="isShowCompatibilityImg"></compatible-warning>
    <div v-else class="ccui-main-container myLayouts">
      <el-top-nav-menu-4
        :showHelp="false"
        v-if="type == 'order'"
        ref="topNavMenu"
        :Menu4Href="true"
        :dashboard="homeUrl"
        :logo="logoUrl"
        :minWidth="mainWidth"
        :showInput="false"
        :width="mainWidth + 'px'"
        companyTitle="批量下单"
        @ccuiHelp="appHelp"
        @onSubmitSkip="handleSelect"
      >
        <div class="guanzhu" @click="goFollow">我的关注</div>
      </el-top-nav-menu-4>
      <el-top-nav-menu-4
        v-else
        ref="topNavMenu"
        :Menu4Href="true"
        :dashboard="homeUrl"
        :logo="logoUrl"
        :minWidth="mainWidth"
        :showInput="false"
        :width="mainWidth + 'px'"
        :companyTitle="subTitle"
        @ccuiHelp="appHelp"
        @onSubmitSkip="handleSelect"
      >
        <div
          class="guanzhu"
          v-if="
            !['/inquiry-price-plans-cloud-rent/index'].includes(
              this.$route.path
            )
          "
          @click="goFollow"
        >
          我的关注
        </div>
      </el-top-nav-menu-4>
      <div
        :class="{ 'help-center': helpCenter, 'help-problem': helpProblem }"
        class="main-wrapper ccui-main-wrapper"
      >
        <div
          v-show="sidebar.opened"
          :style="{ position: sidebarPosition }"
          class="sidebar-wrapper no-print"
        >
          <div :style="{ minHeight: sidebarMinHeight }">
            <sidebar
              :left-menu="currentMenuArr"
              :title="subMenuTitle"
              class="sidebar-container"
            />
          </div>
        </div>
        <app-main style="min-height: auto" />
      </div>
      <el-emp-footer
        v-if="isEmpFooter"
        :helpData="helpData"
        :qrCode="qrCode"
        :class="{ fontClass: fontClass }"
      />
      <el-simple-footer
        v-if="isShowSimpleFooter"
        class="ccui-home-index-footer"
      ></el-simple-footer>
    </div>
    <el-dialog
      :show-close="false"
      :visible.sync="dialogVisible"
      custom-class="el-dialog--customize"
      show-divider
      show-shadow
      title="提示"
      width="300px"
    >
      <span>您尚未登录，请先登录</span>
      <span slot="footer" style="text-align: center">
        <el-button size="mini" type="primary-font-mini" @click="goLogin"
          >去登录</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { AppMain, CompatibleWarning, Sidebar } from "./components";
import { addUrlPerFix, isSupportExplore, footerLinks } from "@/utils";
// import ResizeMixin from './mixin/ResizeHandler'
import { isExternal } from "@/utils/validate";
import Cookies from "js-cookie";
import arrows from "@/assets/images/arrows.png";
import qrCode from "@/assets/images/code.jpg";
import { getShopTypeMap } from "@/api/login";

const VUE_APP_EMP_URL = addUrlPerFix(process.env.VUE_APP_EMP_URL);
const VUE_APP_CLP_URL = addUrlPerFix(process.env.VUE_APP_CLP_URL);
export default {
  inject: ["reload"],
  name: "Layout",
  components: {
    Sidebar,
    AppMain,
    // Footer,
    CompatibleWarning
  },
  // mixins: [ResizeMixin],
  data() {
    const isCloudRent = () => {
      return this.$route.path.indexOf("cloud-rent") > -1;
    };
    return {
      type: "",
      logoUrl: isCloudRent()
        ? require("@/icons/img/logo-cloud-rent.png")
        : require("@/icons/img/logo1.png"),
      homeUrl: isCloudRent() ? VUE_APP_CLP_URL : VUE_APP_EMP_URL,
      mainWidth: "1062",
      arrows,
      counter: 0,
      helpCenter: false,
      helpProblem: false,
      isShowSidebar: false,
      isShowSidebarSystem: this.$store.state.app.sidebar.isShowSidebarBtn,
      qrCode: qrCode,
      helpData: [
        {
          tit: "关于我们",
          list: [
            { label: "平台简介", url: footerLinks.introduction },
            { label: "联系我们", url: footerLinks.contactUs }
            // { label: '相关政策与规范', url: '' }
          ]
        },
        {
          tit: "采购方",
          list: [
            { label: "操作指引", url: footerLinks.guide }
            // { label: '视频教程', url: '' }
          ]
        },
        {
          tit: "供应商",
          list: [
            { label: "操作指引", url: footerLinks.guide },
            // { label: '视频教程', url: '' },
            { label: "入网须知", url: footerLinks.guide }
          ]
        },
        // {
        //   tit: '常见问题',
        //   list: [
        //     { label: '采购方常见问题', url: '' },
        //     { label: '供应商常见问题', url: '' }
        //   ]
        // },
        {
          tit: "服务中心",
          list: [
            { label: "在线咨询", url: "" },
            { label: "售后服务", url: "" },
            { label: "意见反馈", url: "" },
            { label: "文件模板下载", url: "" }
          ]
        },
        {
          tit: "供应链金融中心",
          list: [
            { label: "操作指引", url: "" },
            { label: "常见问题", url: "" }
          ]
        }
      ],
      topMenuObj: {},
      routeMenu: [],
      leftMenu: [],
      subMenuTitle: "",
      currentMenuObj: {},
      currentParentMenuObj: {},
      tempMenu: [],
      menuInit: [],
      activeIndex: "2",
      isShowCompatibilityImg: true,
      sidebarPosition: "absolute",
      sidebarMinHeight: "calc(100vh - 160px)"
    };
  },

  watch: {
    $route: {
      handler: function(val, oldVal) {
        let path = this.$route.path;
        if (path.indexOf("helpCenter") !== -1) {
          this.helpCenter = true;
          this.helpProblem = false;
        } else if (
          path.indexOf("helpProblem") !== -1 ||
          path.indexOf("helpManual") !== -1
        ) {
          this.helpCenter = false;
          this.helpProblem = true;
        } else {
          this.helpCenter = false;
          this.helpProblem = false;
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true
    }
  },

  computed: {
    subTitle() {
      if (
        ["/inquiry-price-plans-cloud-rent/index"].includes(this.$route.path)
      ) {
        return "按计划询价";
      }
      if (this.$route.path.includes("favorite")) {
        return "我的关注";
      }
      return "购物车";
    },
    fontClass() {
      return [
        "/inquiry-price-goods-cloud-rent/index",
        "/inquiry-price-plans-cloud-rent/index"
      ].includes(this.$route.path);
    },
    isShowSimpleFooter() {
      return this.$store.state.app.isShowSimpleFooter;
    },
    isEmpFooter() {
      return this.$store.state.app.isEmpFooter;
    },
    dialogVisible() {
      return this.$store.state.app.isShowDialog;
    },
    menu() {
      return this.$store.state.app.menu || [];
      // return this.menuInit;
    },
    isShowFooter() {
      return this.$store.state.app.isShowFooter;
    },
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
        "cloud-rent": [
          "/inquiry-price-goods-cloud-rent/index",
          "/inquiry-price-plans-cloud-rent/index"
        ].includes(this.$route.path)
      };
    },
    currentMenuArr() {
      return this.$store.state.app.currentMenuArr;
    }
  },
  created() {
    this.isShowCompatibilityImg = !isSupportExplore();
    this.getShopTypeMap();
  },

  mounted() {
    if (window.location.href.split("?")[1]) {
      console.log(
        window.location.href.split("?")[1].split("=")[1],
        'window.location.href.split("?")[1].split("=")[1];'
      );
      this.type = window.location.href.split("?")[1].split("=")[1];
    }
    let that = this;
    window.onresize = function windowResize() {
      // 通过捕获系统的onresize事件触发我们需要执行的事件
      // this.mainWidth = (window.innerWidth - 500) + 'px';
      if (document.documentElement.clientWidth > 1280) {
        that.mainWidth = "1162";
        that.$refs.topNavMenu.style.width = "1162";
      } else {
        that.mainWidth = "1062";
        that.$refs.topNavMenu.style.width = "1062";
      }
      // if (!that.$route.path.split(",").includes("/index")) {
      //   that.reload();
      // }
    };
    if (this.$route.path === "/test/test") {
      return;
    }
    this.$store.dispatch("setMenu", this.menu);

    // 这里控制用哪一级路由来定位菜单
    if (this.$route.matched && this.$route.matched.length > 2) {
      // debugger
      this.setMenu(this.$store.state.app.menu, this.$route.matched[1].name); // 四级用三级的name做定位菜单
    } else {
      this.setMenu(this.$store.state.app.menu, this.$route.name); // this.$route.name 用于定位菜单
    }

    const sidebarStatus = Cookies.get("sidebarStatus") - 0;
    this.isShowSidebar = !!sidebarStatus;
    if (document.documentElement.clientWidth > 1280) {
      this.mainWidth = "1162";
    } else {
      this.mainWidth = "1062";
    }
    window.addEventListener("scroll", this.windowScroll);

    // Ai客服
    const paragraphs = document.querySelectorAll(".help-list p");
    paragraphs.forEach(function(paragraph) {
      if (paragraph.textContent === "在线咨询") {
        paragraph.style.cursor = "pointer";
        paragraph.addEventListener("click", function() {
          console.log("点击了“在线咨询”");
          // 获取顶部导航的在线客服然后点击
          const zx = document.querySelector(".app-item.zaixian");
          zx && zx.click();
        });
      }
    });
  },
  methods: {
    getShopTypeMap() {
      getShopTypeMap()
        .then(res => {
          console.log("🚀 ~ getShopTypeMap ~ res:", res);
          if (res.data.code === "0") {
            const result = {};
            Object.entries(res.data.data).forEach(([key, item]) => {
              item.forEach(n => {
                n.value = n.code;
              });
              result[key] = item;
            });
            // TODO: 获取shopType逻辑需优化
            this.$store.dispatch("setShopTypeMap", result);
          }
        })
        .catch(err => {
          console.log("🚀 ~ getShopTypeMap ~ err:", err);
        });
    },
    goFollow() {
      // this.$router.push("/favorite");
      window.open(
        this.$addUrlPerFix(process.env.VUE_APP_BASE_URL) + "/favorite"
      );
    },
    appHelp() {
      this.$router.push("/helpAndSupport");
    },
    cancel() {},
    goLogin() {
      window.location.href = this.$addUrlPerFix(process.env.VUE_APP_LOGIN_URL);
    },
    userPanelClickHandler(index) {
      if (this.menu[index].url === "/to-be-built/index") {
        this.$message("工程建设中");
        return;
      }

      const len = this.menu.length;
      for (let i = 0; i < len; i++) {
        if (i === index) {
          // this.$router.push(this.menu[i].url)
          if (this.menu[i].url.indexOf("http") !== -1) {
            window.location.href = this.menu[i].url;
          } else {
            this.$router.push(this.menu[i].url);
          }
          if (this.tempMenu.length) {
            const len1 = this.tempMenu.length;
            for (let j = 0; j < len1; j++) {
              if (this.tempMenu[j].id === this.menu[i].id) {
                return;
              }
            }
          }
          this.menu[i].isNotShow = false;
          this.tempMenu.push(this.menu[i]);
        }
      }

      if (this.tempMenu.length > 1) {
        const shiftItem = this.tempMenu.shift();
        this.menu.forEach(item => {
          if (item.id === shiftItem.id) {
            item.isNotShow = true;
          }
        });
      }
    },
    handleClickOutside() {
      this.$store.dispatch("closeSidebar", { withoutAnimation: false });
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    onJump(obj) {
      this.routeMenu = [];
      this.subMenuTitle = "";

      if (!isExternal(obj.url)) {
        this.$router.push(obj.url);
        if (obj.isShowSideBar) {
          this.setMenuToRoute(obj);
          this.$store.dispatch("openSidebarTemporary");
        } else {
          this.$store.dispatch("closeSidebarTemporary");
        }
      } else {
        this.handleClickOutside();
      }
    },
    routerObj2MenuObj(item) {
      const menuObj = {};
      menuObj.subMenuTitle = item.name;
      if (item.subMenu.length) {
        const subMenuArr = [];
        item.subMenu.forEach(menuItem => {
          subMenuArr.push(this.trans(menuItem));
        });
        menuObj.subMenu = subMenuArr;
      }
      return menuObj;
    },
    setMenuToRoute(obj) {
      // const that = this
      if (obj.subMenu.length) {
        const arr = obj.subMenu;
        const arrMenu = [];

        arr.forEach(item => {
          const menuObj = this.routerObj2MenuObj(item);
          arrMenu.push(menuObj);
        });
        this.$store.dispatch("setCurrentMenuArr", arrMenu);

        this.leftMenu = this.$store.state.app.currentMenuArr;

        this.subMenuTitle = obj.subMenu[0].name;

        const routeObj = this.trans(obj);
        const subMenu = [];
        obj.subMenu.forEach(item => {
          if (item.subMenu.length) {
            item.subMenu.forEach(item => {
              const objTemp = this.trans(item);
              subMenu.push(objTemp);
            });
            routeObj.children = subMenu;
          }
        });

        this.routeMenu = subMenu;
      }
    },
    trans(obj) {
      const _routeObj = {};
      _routeObj.name = obj.name;
      _routeObj.path = obj.url;
      _routeObj.redirect = obj.redirect || "";
      _routeObj.meta = obj.meta || {};
      _routeObj.meta.title = obj.name;
      _routeObj.meta.isNotShow = obj.isNotShow;
      return _routeObj;
    },
    setMenu(arr, menuCode) {
      const that = this;

      if (arr.length !== 0) {
        var traverse = arr => {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].subMenu && arr[i].subMenu.length !== 0) {
              // 获取当前菜单
              if (arr[i].menuCode === menuCode) {
                // 获取当前菜单的父菜单
                that.currentMenuObj = arr[i];
                that.setParentMenu(that.menu, arr[i].pid, arr[i].id);
              }
              traverse(arr[i].subMenu);
            } else {
              if (arr[i].menuCode === menuCode) {
                // 获取当前菜单的父菜单
                that.currentMenuObj = arr[i];
                that.setParentMenu(that.menu, arr[i].pid, arr[i].id);
              }
            }
          }
        };
        traverse(arr);
      }
    },
    setParentMenu(arr, pid, index) {
      if (arr.length !== 0) {
        var traverse = arr => {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].subMenu && arr[i].subMenu.length !== 0) {
              // 获取父菜单
              if (arr[i].id === pid) {
                // 获取三级菜单的上级菜单
                if (arr[i].id.split("-").length === 2) {
                  this.currentParentMenuObj = arr[i];
                  arr[i].activeIndex = index;
                  // return
                }
                // 获取二级菜单的上级菜单
                if (arr[i].id.split("-").length === 1) {
                  arr[i].activeIndex = index;
                }

                // 设置上级菜单
                this.setParentMenu(this.menu, arr[i].pid, arr[i].id);
              }
              traverse(arr[i].subMenu);
            } else {
              if (arr[i].id === pid) {
                arr[i].activeIndex = index;
              }
            }
          }
        };
        traverse(arr);
      }

      if (
        this.currentParentMenuObj.subMenu &&
        this.currentParentMenuObj.subMenu.length
      ) {
        this.setMenuToRoute(this.currentParentMenuObj);
      }
    },
    logout() {
      window.location.href = "http://tmpl.iccec.cn/";
    },
    windowScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.sidebarPosition = scrollTop >= 120 ? "fixed" : "absolute";
      this.sidebarMinHeight =
        scrollTop >= 120 ? "calc(100vh - 40px)" : "calc(100vh - 160px)";
      if (document.documentElement.clientWidth > 1280) {
        this.mainWidth = "1162";
      } else {
        this.mainWidth = "1062";
      }
    }
  }
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";
/deep/
  .el-top-nav-menu4
  .sub-menu-wrapper-wrapper
  .sub-menu-wrapper
  .logo-container {
  align-items: center !important;
  img {
    width: 160px !important;
    height: auto !important;
  }
}

html,
body {
  min-height: 100%;
}

.main-wrapper {
  padding-top: 0 !important;
}

.main-wrapper.ccui-main-wrapper.help-center {
  @media screen and (max-width: 1280px) {
    /deep/ .ccui-app-container {
      width: 1022px;
    }
  }
  @media screen and (min-width: 1281px) {
    /deep/ .ccui-app-container {
      width: 1120px;
    }
  }

  /deep/ .ccui-app-container {
    /*width: 1120px;*/
    margin: 0 auto;
    margin-top: 20px;
  }
}

.main-wrapper.ccui-main-wrapper.help-problem {
  @media screen and (max-width: 1280px) {
    /deep/ .ccui-tree-table {
      width: 1062px;
    }
  }
  @media screen and (min-width: 1281px) {
    /deep/ .ccui-tree-table {
      width: 1162px;
    }
  }

  /deep/ .ccui-tree-table {
    /*width: 1180px;*/
    margin: 0 auto;
    margin-top: 10px;
  }
}

// .my-cards {
//   padding: 20px 0 !important;
// }
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }

  .main-container {
    //width: 1440px;
    /*position: relative;*/

    min-height: 100%;
    background-color: #f1f1f1;
    //transition: margin-left .28s;
    //margin-left: $sideBarWidth;
    .main-wrapper {
      position: relative;
      min-width: 1062px;
      max-width: 1680px;
      margin: 0 auto;

      .sidebar-wrapper {
        position: absolute;
        top: 20px;
        width: 180px;
        /*min-height: calc(100vh - 124px);*/
        /*border: 1px solid #ececec;*/
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.07);
        border-top: 0;

        & > div {
          position: relative;
          min-height: calc(100vh - 160px);
        }
      }

      .toggle-btn {
        position: absolute;
        top: 24px;
        left: 186px;
        cursor: pointer;
        width: 12px;
        height: 30px;
        background: rgba(85, 118, 207, 1);
        border-radius: 6px;
      }
    }
  }

  &.hideSidebar {
    .main-container {
      .main-wrapper {
        /deep/ .toggle-btn {
          /*margin: 0;*/
          top: 24px;
          left: 4px;
        }

        /deep/ .sidebar-wrapper {
          left: 0 !important;
        }
      }
    }
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
/deep/
  .fontClass
  .service
  .wrapper
  .service-list
  .service-item
  .service-unit
  i {
  color: #0089ef !important;
}
</style>
<style lang="scss" rel="stylesheet/scss">
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.myLayouts {
  .el-top-nav-menu4 .icon-ccui-help {
    right: 50px !important;
    display: none;
  }
  .guanzhu {
    position: absolute;
    // right: 82px;
    right: 50px;
    font-size: 16px;
    top: 29px;
    font-weight: 600;
    color: #fff;
    cursor: pointer;
  }
}

.main-container {
  /deep/ .sub-menu-wrapper-wrapper {
    padding-left: 0px;
  }

  @media screen and (max-width: 1280px) {
    /deep/ .sub-menu-wrapper {
      width: 1062px;
    }
  }
  @media screen and (min-width: 1281px) {
    /deep/ .sub-menu-wrapper {
      width: 1162px;
    }
  }
}

.el-popover.user-popover {
  top: 27px !important;
  padding-top: 0 !important;
  border-radius: 0 !important;

  .el-menu {
    border: 0;

    .el-menu-item {
      margin: 0 -4px;
      padding-left: 4px !important;
      padding-right: 4px;
      height: 32px;
      line-height: 32px;

      &.user-info {
        height: 54px;
        line-height: 54px;
        border-bottom: 1px solid $--color-assist-background;
      }

      &.show-bottom-line {
        border-bottom: 1px solid $--color-assist-background;
      }

      .icon-ccui-user-wrapper {
        margin-bottom: 0;
        display: inline-block;
        color: #fff;
        width: 14px;
        height: 14px;
        font-size: 14px;
        border-radius: 7px;
        background-color: $--color-primary;
        overflow: hidden;

        i {
          color: $white;
        }

        span {
          color: #666;
        }
      }
    }
  }
}
</style>
